import { AddressFields } from '../types';

export const useFormatAddress = (address: AddressFields): AddressFields => {
  const address1 = address.address ?? '';
  const address2 = address.address2 ?? '';
  const city = address.city ?? '';
  const country = address.country ?? '';
  const state = address.state ?? '';
  const zip = address.zip ?? '';

  return {
    address: address1,
    address2,
    city,
    country,
    state,
    zip,
  };
};
